import moment from "moment";

export const inquiryCount = (arr, days) => {
  let count = 0;

  for (let i = 0; i < arr.length; i++) {
    if ((moment() - arr[i].createdTime) / 86400000 < days) {
      count++;
    }
  }
  return count;
};

export const sortContacts = (arr, days) => {
  const types = {
    inquiry: [],
    contacted: [],
    prospect: [],
    customer: [],
    waitlist: [],
    vip: [],
    designer: [],
    vendor: [],
    contractor: [],
  };
  for (let i = 0; i < arr.length; i++) {
    if ((moment() - arr[i].createdTime) / 86400000 < days) {
      if (typeof arr[i].contactType !== "undefined") {
        types[arr[i].contactType.toLowerCase()].push(arr[i]);
      }
    }
  }

  return types;
};
